import { InjectionToken, type WritableSignal } from '@angular/core';
import { type Observable } from 'rxjs';

import { type ComparisonQueryNode } from '@blaze-shared/api-contracts-domain';
import { type IntelliConfig, type QueryOperatorOption } from '@blaze-shared/intellisense-feature';
import { type ColumnFieldOption } from '@blaze-shared/schema-domain';
import { type SelectOption } from '@blaze-shared/shared-util';

import { type ComparisonQueryFormGroupValue } from '../complex-filter.models';

export const COMPLEX_FILTER_SERVICE = new InjectionToken('COMPLEX_FILTER_SERVICE');

export type AfterDeletingLastRowBehavior = 'insert';

export interface ComplexFilterService {
  readonly showIgnoreWhenEmptyToggle: WritableSignal<boolean>;

  afterDeletingLastRow?: AfterDeletingLastRowBehavior;

  getColumns(): Observable<SelectOption<ColumnFieldOption>[]>;

  getErrors?(
    query: ComparisonQueryFormGroupValue,
    column: keyof ComparisonQueryNode,
  ): Observable<string[]>;

  getIntelliConfig(
    queryCondition$: Observable<ComparisonQueryFormGroupValue>,
  ): Observable<IntelliConfig>;

  getOperators(
    queryCondition$: Observable<ComparisonQueryFormGroupValue>,
  ): Observable<QueryOperatorOption[]>;
}
